import { render, staticRenderFns } from "./Workspaces_mobile.vue?vue&type=template&id=a2162b86&"
import script from "./Workspaces_mobile.vue?vue&type=script&lang=js&"
export * from "./Workspaces_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Workspaces_mobile.vue?vue&type=style&index=0&id=a2162b86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports